export default "__VITE_ASSET__BJrky5pS__"